import { useMemo } from 'react';
import type { HomeworkSurfaceSpec } from './types';
import { emptySurfaceValue } from './types';
import { FreeText } from './FreeText';
import { StoryForm } from './StoryForm';
import { AcList } from './AcList';
import { MoscowBoard } from './MoscowBoard';
import { BugReportForm } from './BugReportForm';
import { TestCaseForm } from './TestCaseForm';
import { TableForm } from './TableForm';
import { CodeForm } from './CodeForm';

interface HomeworkSurfaceProps {
  spec: HomeworkSurfaceSpec;
  value: Record<string, unknown> | undefined;
  disabled?: boolean;
  onChange: (value: Record<string, unknown>, filled: boolean) => void;
}

/** Dispatcher: renders the working surface for a homework by kind. */
export function HomeworkSurface({ spec, value, disabled, onChange }: HomeworkSurfaceProps) {
  const v = useMemo(() => value ?? emptySurfaceValue(spec), [value, spec]);
  const props = { spec, value: v, disabled, onChange };
  switch (spec.kind) {
    case 'storyForm': return <StoryForm {...props} />;
    case 'acList': return <AcList {...props} />;
    case 'moscowBoard': return <MoscowBoard {...props} />;
    case 'bugReport': return <BugReportForm {...props} />;
    case 'testCase': return <TestCaseForm {...props} />;
    case 'table': return <TableForm {...props} />;
    case 'code': return <CodeForm {...props} />;
    case 'freeText':
    default: return <FreeText {...props} />;
  }
}
